import { Component, Input, OnInit } from '@angular/core';
import { StatusBag } from '@app/enums';
/**
 * Componente para mostrar el precio de una bolsa de mano (carry-on).
 * 
 * Este componente muestra el precio de una bolsa de mano, el estado de la bolsa y la cantidad total,
 * incluyendo el código de la moneda utilizada.
 *
 */
@Component({
    selector: 'am-bag-price-carryon',
    templateUrl: './am-bag-price-carryon.component.html',
    styleUrls: ['./am-bag-price-carryon.component.scss'],
    standalone: false
})
export class AmBagPriceCarryonComponent implements OnInit {

  /**
   * Estado de la bolsa de mano (carry-on). Este valor es de tipo `StatusBag` y se pasa como input desde el componente padre.
   * 
   * @type {StatusBag}
   */
  @Input() statusBag: StatusBag;

  /**
   * Monto total asociado a la bolsa de mano. Este valor es numérico y se pasa como input desde el componente padre.
   * 
   * @type {number}
   */
  @Input() totalAmount: number;

  /**
   * Código de la moneda utilizada para el monto. Este valor es un string y se pasa como input desde el componente padre.
   * 
   * @type {string}
   */
  @Input() currencyCode: string;

  /**
   * Enum de `StatusBag` para poder utilizar los diferentes estados de la bolsa dentro del componente.
   * 
   * @type {typeof StatusBag}
   */
  StatusBag = StatusBag;
  constructor() { }

  ngOnInit(): void {
  }

}
